import { Injectable, inject } from '@angular/core';
import {
  ClientFile,
  ClientFileType,
  DefaultResponse,
  GetFileListResponse,
  NewFileResponse,
} from '@codegen';
import { DefaultService } from '@codegen/service';
import {
  CallbackPayload,
  DocumentUploadPayload,
} from '@modules/documents/documents.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private resource = inject(DefaultService);

  public getNeeded(): Observable<ClientFileType[]> {
    return this.resource.fileNeeded().pipe(map(i => i.fileTypes));
  }

  public getAllDocuments(): Observable<GetFileListResponse> {
    return this.resource.fileAll();
  }

  public upload(payload: DocumentUploadPayload): Observable<string> {
    return this.resource.fileAdd(payload).pipe(map(i => i.fileId));
  }

  public getOne(fileId: string): Observable<ClientFile> {
    return this.resource.fileFindById({ fileId }).pipe(
      map(i => {
        const updatedFile = {
          ...i.file,
          mimetype: i.file.mimetype.toLowerCase(),
        };
        return updatedFile;
      })
    );
  }

  public delete(fileId: string): Observable<NewFileResponse> {
    return this.resource.fileDelete({ fileId });
  }

  public sign(fileId: string): Observable<DefaultResponse> {
    return this.resource.fileSign({ fileId });
  }

  public callback(payload: CallbackPayload): Observable<DefaultResponse> {
    return this.resource.fileCallback(payload);
  }
}
